import React from "react";
import { Stack, Typography } from "@mui/material";

const PMH = ({ pastSurgicalHistory }) => {
  return (
    <Stack direction="column">
      <Typography variant="h5" fontWeight="bold">
        PAST SURGICAL HISTORY:
      </Typography>
      {pastSurgicalHistory.length > 0 ? (
        <Typography variant="h6">
          Surgical History includes: {pastSurgicalHistory.join(", ")}
        </Typography>
      ) : (
        <Typography variant="h6">None</Typography>
      )}
    </Stack>
  );
};

export default PMH;
